/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationOr } from '../../models/organization-or';

export interface GetOrganizationsWithGeneralSettings$Params {
  orid?: number;
}

export function getOrganizationsWithGeneralSettings(http: HttpClient, rootUrl: string, params?: GetOrganizationsWithGeneralSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationOr>>> {
  const rb = new RequestBuilder(rootUrl, getOrganizationsWithGeneralSettings.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationOr>>;
    })
  );
}

getOrganizationsWithGeneralSettings.PATH = '/api/GeneralSettings/getOrganizationsWithGeneralSettings';
